import { c as _c } from "react/compiler-runtime";
import { ChainId } from '@morpho-org/blue-sdk';
import { parseApiAsset, ZERO } from '@morpho-org/dapp-core';
import { Avatar } from '@morpho-org/ui-v6/client';
import { Skeleton, Tag } from '@morpho-org/ui-v6/server';
import { formatters } from '@morpho-org/ui-v6/utils';
import { useQuery } from '@tanstack/react-query';
import { useMorphoLegacyContext } from '@/contexts/MorphoLegacy/MorphoLegacy.context';
import { mainnetAddresses } from '@/helpers/addresses';
import { orpc } from '@/lib/orpc/client';
import { RecapContainer, type RecapMode } from './RecapContainer';
export interface WrapMorphoLegacyRecapProps {
  mode: RecapMode;
}
const WrapMorphoLegacyRecap = t0 => {
  const $ = _c(27);
  const {
    mode
  } = t0;
  const {
    legacyMorphoHolding
  } = useMorphoLegacyContext();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = orpc.token.root.queryOptions({
      input: {
        chainId: ChainId.EthMainnet,
        address: mainnetAddresses.morphoToken
      }
    });
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    data: token,
    isLoading: loading
  } = useQuery(t1);
  let t2;
  if ($[1] !== legacyMorphoHolding.value) {
    t2 = formatters.commas.digits(2).of(legacyMorphoHolding.value ?? ZERO, 18);
    $[1] = legacyMorphoHolding.value;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const formattedAmount = t2;
  let t3;
  if ($[3] !== legacyMorphoHolding.value || $[4] !== token) {
    const amountUsd = parseApiAsset(token && {
      address: token.address,
      symbol: token.symbol ?? "MORPHO",
      name: token.name ?? "MORPHO",
      decimals: token.decimals,
      logoURI: token.logoUri,
      chain: {
        id: token.chainId
      },
      priceUsd: token.priceUsd
    })?.toUsd(legacyMorphoHolding.value ?? ZERO);
    t3 = formatters.short.digits(2).default("0").unit("$").trailingZero(false).of(amountUsd, 18);
    $[3] = legacyMorphoHolding.value;
    $[4] = token;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const formattedAmountUsd = t3;
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <span className="text-foreground line-clamp-1 text-sm">Wrap Legacy MORPHO</span>;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== formattedAmount) {
    t5 = <span className="text-title-xs text-foreground">{formattedAmount}</span>;
    $[7] = formattedAmount;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <span className="text-title-xs text-muted-foreground">MORPHO</span>;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t5) {
    t7 = <div className="gap-2xs flex">{t5}{t6}</div>;
    $[10] = t5;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== formattedAmountUsd || $[13] !== loading) {
    t8 = loading ? <Skeleton className="h-[26px] w-[62px] rounded-[20px]" /> : <Tag variant="bundler"><span className="text-3xs text-foreground" style={{
        lineHeight: "normal"
      }}>{formattedAmountUsd}</span></Tag>;
    $[12] = formattedAmountUsd;
    $[13] = loading;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t7 || $[16] !== t8) {
    t9 = <div className="gap-2xs flex items-center">{t7}{t8}</div>;
    $[15] = t7;
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== loading || $[19] !== token?.logoUri) {
    t10 = loading ? <Skeleton className="h-[24px] w-[24px] rounded-[20px]" /> : <Avatar src={token?.logoUri} size="medium" padding={0} />;
    $[18] = loading;
    $[19] = token?.logoUri;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== t10 || $[22] !== t9) {
    t11 = <div className="gap-sm flex flex-col items-stretch"><div className="gap-sm flex flex-col items-stretch">{t4}<div className="flex justify-between">{t9}{t10}</div></div></div>;
    $[21] = t10;
    $[22] = t9;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== mode || $[25] !== t11) {
    t12 = <RecapContainer className="gap-lg flex-col" mode={mode}>{t11}</RecapContainer>;
    $[24] = mode;
    $[25] = t11;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  return t12;
};
export default WrapMorphoLegacyRecap;